import React, { useState } from 'react';
import styled from 'styled-components';

interface ButtonProps {
  fileInput?: boolean;
  fn?: any;
  txt?: string;
  checked?: boolean;
  disabled?: boolean;
  btnName?: string;
}
const Text = styled.span`
  position: relative;
  display: block;
  font-size: 15px;
  font-family: 'SDGothicNeobTTF-bLt';
  word-break: keep-all;
  word-wrap: break-word;
  color: #ff671d;
  margin: 0;
  padding: 0;
`;
const ButtonContainer = styled.button`
  font-size: 15px;
  font-family: 'SDGothicNeobTTF-bLt';
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
  word-break: keep-all;
  word-wrap: break-word;
  width: 100%;
  margin-right: 10px;
  padding: 0.875rem 1.3125rem 0.875rem;
  margin-top: 10px;

  &.btn-full01 {
    border: 1px solid #ff671d;
    background-color: #ff671d;
    ${Text} {
      color: #fff;
    }
  }
  &.btn-full02 {
    border: 1px solid #e5e5e5;
    background-color: #e5e5e5;
    ${Text} {
      color: #999;
    }
  }
  &.btn-full03 {
    border: 1px solid #999;
    background-color: #999;
    ${Text} {
      color: #fff;
    }
  }
  &.btn-full04 {
    border: 1px solid #ccc;
    background-color: #fff;
    ${Text} {
      color: #999;
    }
  }
`;

const ButtonType04: React.FC<ButtonProps> = ({ txt, fn, disabled, btnName, fileInput }) => {
  const [click, setClick] = useState(false);
  const handleClick = (val?: any) => {
    setClick(!click);
    if (fn) {
      fn(val);
    }
  };

  return (
    <>
      <ButtonContainer onClick={() => handleClick()} className={btnName}>
        <Text>{txt}</Text>
      </ButtonContainer>
    </>
  );
};

export default ButtonType04;
